import * as Actions from 'app/store/actions/streaming/streaming.actions';

const initialState = {
	data: null,
	categories: []
};

const StreamingReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_STREAMING: {
			return {
				...state,
				data: action.payload
			};
		}
		case Actions.GET_CATEGORIES: {
			return {
				...state,
				categories: action.payload
			};
		}
		default: {
			return state;
		}
	}
};

export default StreamingReducer;
